import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { PROFILE_STYLES } from '../consts';
import Icon from '../../../generic-components/Icon';
import LimitsIcon from '../../../assets/svg/trx-limits.svg';
import Button from '../../../generic-components/Button';
import { VIEWS_MAP } from '../../../router/constants';

export const TransactionLimitBlock = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div>
      <Button
        id='transaction_limits'
        title={t('PROFILE_TRANSACTIONS_LIMITS')}
        className={PROFILE_STYLES.TRANSACTIONS_LIMITS}
        childElement={<Icon className='w-[24px] h-[24px] mr-[4px]' src={LimitsIcon} />}
        onClick={() => navigate(`/${VIEWS_MAP.ACCOUNT_LIMITS}`)}
      />
    </div>
  );
};
